<template>
  <section class="app-main" @click="hidePanel">
    <div class="mbTip">
      温馨提示：触发消息必须同时触发发送，中英文触发内容、中英文标题为必填项！
    </div>
    <div class="textarea">
      <div class="msgEdit">
        <el-input
          type="text"
          placeholder="请输入中文标题"
          v-model="zh_name"
          autocomplete="off"
          style="width: 100%"
        >
        </el-input>
        <el-input
          type="text"
          placeholder="请输入中文链接"
          v-model="zh_link"
          autocomplete="off"
          style="width: 100%; margin-top: 10px"
        >
        </el-input>
        <div class="emjioBox" id="emjioBox" v-if="viewEmjio">
          <div class="emjioMain">
            <span
              v-for="(item, index) in emjioStr.split(',')"
              :key="index"
              @click="submitEmjio(item, 1)"
              @mouseenter="emjioActive = item"
            >
              {{ item }}
            </span>
          </div>
          <div class="emjioList">
            <span
              v-for="(item, index) in emjio"
              :key="index"
              @mouseenter="emjioStr = item"
              >{{ index }}</span
            >
          </div>

          <div class="viewEmjio">{{ emjioActive }}</div>
        </div>
        <div class="msgTools">
          <span>
            <img
              @click.stop="viewEmjio = !viewEmjio"
              :src="
                viewEmjio
                  ? require('@/assets/icon/expression2.png')
                  : require('@/assets/icon/expression.png')
              "
              alt=""
            />
          </span>
          <span>
            <img
              @click="zh_textarea += '[money]'"
              src="@/assets/icon/money.png"
              alt=""
            />
          </span>
          <span>
            <img
              @click="zh_textarea += '[name]'"
              src="@/assets/icon/person.png"
              alt=""
            />
          </span>
          <span>
            <img
              @click="zh_textarea += '[day]'"
              src="@/assets/icon/day.png"
              alt=""
            />
          </span>
          <span>
            <img
              @click="zh_textarea += '[month]'"
              src="@/assets/icon/month.png"
              alt=""
            />
          </span>
        </div>
        <el-input
          id="msgContent"
          type="textarea"
          placeholder="请输入中文推送内容，示例：内容#*****#包裹跳转超链接"
          v-model="zh_textarea"
          :rows="5"
          show-word-limit
          autocomplete="off"
          style="margin-top: 5px"
        >
        </el-input>
      </div>
      <div class="msgEdit">
        <el-input
          type="text"
          placeholder="请输入英文标题"
          v-model="en_name"
          autocomplete="off"
          style="width: 100%"
        >
        </el-input>
        <el-input
          type="text"
          placeholder="请输入英文标题"
          v-model="en_link"
          autocomplete="off"
          style="width: 100%; margin-top: 10px"
        >
        </el-input>
        <div class="emjioBox" id="emjioBox2" v-if="viewEmjio2">
          <div class="emjioMain">
            <span
              v-for="(item, index) in emjioStr.split(',')"
              :key="index"
              @click="submitEmjio(item, 2)"
              @mouseenter="emjioActive = item"
            >
              {{ item }}
            </span>
          </div>
          <div class="emjioList">
            <span
              v-for="(item, index) in emjio"
              :key="index"
              @mouseenter="emjioStr = item"
              >{{ index }}</span
            >
          </div>

          <div class="viewEmjio">{{ emjioActive }}</div>
        </div>
        <div class="msgTools">
          <span>
            <img
              @click.stop="viewEmjio2 = !viewEmjio2"
              :src="
                viewEmjio2
                  ? require('@/assets/icon/expression2.png')
                  : require('@/assets/icon/expression.png')
              "
              alt=""
            />
          </span>
          <span>
            <img
              @click="en_textarea += '[money]'"
              src="@/assets/icon/money.png"
              alt=""
            />
          </span>
          <span>
            <img
              @click="en_textarea += '[name]'"
              src="@/assets/icon/person.png"
              alt=""
            />
          </span>
          <span>
            <img
              @click="en_textarea += '[day]'"
              src="@/assets/icon/day.png"
              alt=""
            />
          </span>
          <span>
            <img
              @click="en_textarea += '[month]'"
              src="@/assets/icon/month.png"
              alt=""
            />
          </span>
        </div>
        <el-input
          id="msgContent2"
          type="textarea"
          placeholder="请输入英文推送内容，示例：内容#*****#包裹跳转超链接"
          v-model="en_textarea"
          :rows="5"
          show-word-limit
          autocomplete="off"
          style="margin-top: 5px"
        >
        </el-input>
      </div>
    </div>
    <div class="send_person">
      <el-radio-group v-model="status">
        <!-- <el-radio :label="1" border>未下单用户</el-radio>
        <el-radio :label="2" border>下单用户</el-radio> -->
        <el-radio :label="3" border>全部用户</el-radio>
        <el-radio :label="4" border>指定用户</el-radio>
        <el-input
          v-if="status == 4"
          v-model="send_person"
          type="text"
          placeholder="请输入推送用户账号,英文逗号隔开"
        ></el-input>
      </el-radio-group>
    </div>
    <div class="submit">
      <el-button type="primary" round @click="submit">推送</el-button>
    </div>

  </section>
</template>

<script>
import { push_add } from "@/api/market.js";

export default {
  data() {
    return {
      zh_textarea: "",
      en_textarea: "",
      viewEmjio: false, // 显示表情
      viewEmjio2: false,
      zh_link: "",
      en_link: "",
      zh_name: "",
      en_name: "",
      emjio: {
        表情:
          "😀,😁,😂,😃,😄,😅,😆,😉,😊,😋,😎,😍,😘,😗,😙,😚,😇,😐,😑,😶,😏,😣,😥,😮,😯,😪,😫,😴,😌,😛,😜,😝,😒,😓,😔,😕,😲,😷,😖,😞,😟,😤,😢,😭,😦,😧,😨,😬,😰,😱,😳,😵,😡,😠",
        人物:
          "👦,👧,👨,👩,👴,👵,👶,👱,👮,👲,👳,👷,👸,💂,🎅,👰,👼,💆,💇,🙍,🙎,🙅,🙆,💁,🙋,🙇,🙌,🙏,👤,👥,🚶,🏃,👯,💃,👫,👬,👭,💏,💑,👪",
        手势: "💪,👈,👉,☝,👆,👇,✌,✋,👌,👍,👎,✊,👊,👋,👏,👐,✍",
        日常:
          "📱,📲,📶,📳,📴,☎,📞,📟,📠,👣,👀,👂,👃,👅,👄,💋,👓,👔,👕,👖,👗,👘,👙,👚,👛,👜,👝,🎒,💼,👞,👟,👠,👡,👢,👑,👒,🎩,🎓,💄,💅,💍,🌂",
        公共:
          "💘,❤,💓,💔,💕,💖,💗,💙,💚,💛,💜,💝,💞,💟,❣,♻,🏧,🚮,🚰,♿,🚹,🚺,🚻,🚼,🚾,⚠,🚸,⛔,🚫,🚳,🚭,🚯,🚱,🚷,🔞,💈",
        动物:
          "🙈,🙉,🙊,🐵,🐒,🐶,🐕,🐩,🐺,🐱,😺,😸,😹,😻,😼,😽,🙀,😿,😾,🐈,🐯,🐅,🐆,🐴,🐎,🐮,🐂,🐃,🐄,🐷,🐖,🐗,🐽,🐏,🐑,🐐,🐪,🐫,🐘,🐭,🐁,🐀,🐹,🐰,🐇,🐻,🐨,🐼,🐾,🐔,🐓,🐣,🐤,🐥,🐦,🐧,🐸,🐊,🐢,🐍,🐲,🐉,🐳,🐋,🐬,🐟,🐠,🐡,🐙,🐚,🐌,🐛,🐜,🐝,🐞,🦋",
        自然:
          "💐,🌸,💮,🌹,🌺,🌻,🌼,🌷,🌱,🌲,🌳,🌴,🌵,🌾,🌿,🍀,🍁,🍂,🍃,🌍,🌎,🌏,🌐,🌑,🌒,🌓,🌔,🌕,🌖,🌗,🌘,🌙,🌚,🌛,🌜,☀,🌝,🌞,⭐,🌟,🌠,☁,⛅,☔,⚡,❄,🔥,💧,🌊",
        饮食:
          "🍇,🍈,🍉,🍊,🍋,🍌,🍍,🍎,🍏,🍐,🍑,🍒,🍓,🍅,🍆,🌽,🍄,🌰,🍞,🍖,🍗,🍔,🍟,🍕,🍳,🍲,🍱,🍘,🍙,🍚,🍛,🍜,🍝,🍠,🍢,🍣,🍤,🍥,🍡,🍦,🍧,🍨,🍩,🍪,🎂,🍰,🍫,🍬,🍭,🍮,🍯,🍼,☕,🍵,🍶,🍷,🍸,🍹,🍺,🍻,🍴",
        文体:
          "🎪,🎭,🎨,🎰,🚣,🛀,🎫,🏆,⚽,⚾,🏀,🏈,🏉,🎾,🎱,🎳,⛳,🎣,🎽,🎿,🏂,🏄,🏇,🏊,🚴,🚵,🎯,🎮,🎲,🎷,🎸,🎺,🎻,🎬",
        旅游:
          "🌋,🗻,🏠,🏡,🏢,🏣,🏤,🏥,🏦,🏨,🏩,🏪,🏫,🏬,🏭,🏯,🏰,💒,🗼,🗽,⛪,⛲,🌁,🌃,🌆,🌇,🌉,🌌,🎠,🎡,🎢,🚂,🚃,🚄,🚅,🚆,🚇,🚈,🚉,🚊,🚝,🚞,🚋,🚌,🚍,🚎,🚏,🚐,🚑,🚒,🚓,🚔,🚕,🚖,🚗,🚘,🚚,🚛,🚜,🚲,⛽,🚨,🚥,🚦,🚧,⚓,⛵,🚤,🚢,✈,💺,🚁,🚟,🚠,🚡,🚀,🎑,🗿,🛂,🛃,🛄,🛅",
        物品:
          "💌,💎,🔪,💈,🚪,🚽,🚿,🛁,⌛,⏳,⌚,⏰,🎈,🎉,🎊,🎎,🎏,🎐,🎀,🎁,📯,📻,📱,📲,☎,📞,📟,📠,🔋,🔌,💻,💽,💾,💿,📀,🎥,📺,📷,📹,📼,🔍,🔎,🔬,🔭,📡,💡,🔦,🏮,📔,📕,📖,📗,📘,📙,📚,📓,📃,📜,📄,📰,📑,🔖,💰,💴,💵,💶,💷,💸,💳,✉,📧,📨,📩,📤,📥,📦,📫,📪,📬,📭,📮,✏,✒,📝,📁,📂,📅,📆,📇,📈,📉,📊,📋,📌,📍,📎,📏,📐,✂,🔒,🔓,🔏,🔐,🔑,🔨,🔫,🔧,🔩,🔗,💉,💊,🚬,🔮,🚩,🎌,💦,💨",
        标志:
          "♠,♥,♦,♣,🀄,🎴,🔇,🔈,🔉,🔊,📢,📣,💤,💢,💬,💭,♨,🌀,🔔,🔕,✡,✝,🔯,📛,🔰,🔱,⭕,✅,☑,✔,✖,❌,❎,➕,➖,➗,➰,➿,〽,✳,✴,❇,‼,⁉,❓,❔,❕,❗,©,®,™,🎦,🔅,🔆,💯,🔠,🔡,🔢,🔣,🔤,🅰,🆎,🅱,🆑,🆒,🆓,ℹ,🆔,Ⓜ,🆕,🆖,🅾,🆗,🅿,🆘,🆙,🆚,🈁,🈂,🈷,🈶,🈯,🉐,🈹,🈚,🈲,🉑,🈸,🈴,🈳,㊗,㊙,🈺,🈵,▪,▫,◻,◼,◽,◾,⬛,⬜,🔶,🔷,🔸,🔹,🔺,🔻,💠,🔲,🔳,⚪,⚫,🔴,🔵",
        钟表:
          "🕛,🕧,🕐,🕜,🕑,🕝,🕒,🕞,🕓,🕟,🕔,🕠,🕕,🕡,🕖,🕢,🕗,🕣,🕘,🕤,🕙,🕥,🕚,🕦,⌛,⏳,⌚,⏰,⏱,⏲,🕰",
        交通:
          "🚂,🚃,🚄,🚅,🚆,🚇,🚈,🚉,🚊,🚝,🚞,🚋,🚌,🚍,🚎,🚏,🚐,🚑,🚒,🚓,🚔,🚕,🚖,🚗,🚘,🚚,🚛,🚜,🚲,⛽,🚨,🚥,🚦,🚧,⚓,⛵,🚣,🚤,🚢,✈,💺,🚁,🚟,🚠,🚡,🚀",
        办公:
          "📱,📲,☎,📞,📟,📠,🔋,🔌,💻,💽,💾,💿,📀,🎥,📺,📷,📹,📼,🔍,🔎,🔬,🔭,📡,📔,📕,📖,📗,📘,📙,📚,📓,📃,📜,📄,📰,📑,🔖,💳,✉,📧,📨,📩,📤,📥,📦,📫,📪,📬,📭,📮,✏,✒,📝,📁,📂,📅,📆,📇,📈,📉,📊,📋,📌,📍,📎,📏,📐,✂,🔒,🔓,🔏,🔐,🔑",
        箭头: "⬆↗➡↘⬇↙⬅↖↕↔↩↪⤴⤵🔃🔄🔙🔚🔛🔜🔝",
      },
      emjioStr:
        "😀,😁,😂,😃,😄,😅,😆,😉,😊,😋,😎,😍,😘,😗,😙,😚,😇,😐,😑,😶,😏,😣,😥,😮,😯,😪,😫,😴,😌,😛,😜,😝,😒,😓,😔,😕,😲,😷,😖,😞,😟,😤,😢,😭,😦,😧,😨,😬,😰,😱,😳,😵,😡,😠", // 表情字符列表
      emjioActive: "😆",
      send_person: "",
      status: 3,
    };
  },
  methods: {
    submitEmjio(e, index) {
      if (index == 1) {
        var obj = document.getElementById("msgContent");
        if (document.selection) {
          obj.focus();
          var sel = document.selection.createRange();
          sel.text = e;
        } else if (
          typeof obj.selectionStart === "number" &&
          typeof obj.selectionEnd === "number"
        ) {
          var startPos = obj.selectionStart;
          var endPos = obj.selectionEnd;
          var tmpStr = obj.value;
          this.zh_textarea =
            tmpStr.substring(0, startPos) +
            e +
            tmpStr.substring(endPos, tmpStr.length);
        } else {
          this.zh_textarea += e;
        }
      } else {
        var obj2 = document.getElementById("msgContent2");
        if (document.selection) {
          obj2.focus();
          var sel2 = document.selection.createRange();
          sel2.text = e;
        } else if (
          typeof obj2.selectionStart === "number" &&
          typeof obj2.selectionEnd === "number"
        ) {
          var startPos2 = obj2.selectionStart;
          var endPos2 = obj2.selectionEnd;
          var tmpStr2 = obj2.value;
          this.en_textarea =
            tmpStr2.substring(0, startPos2) +
            e +
            tmpStr2.substring(endPos2, tmpStr2.length);
        } else {
          this.en_textarea += e;
        }
      }
    },
    submit() {
      if (
        this.zh_textarea != "" &&
        this.en_textarea != "" &&
        this.en_name != "" &&
        this.zh_name != ""
      ) {
        this.$confirm("此操作将提交中英文端触发消息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              zh_name: this.zh_name,
              en_name: this.en_name,
              content_zh: this.zh_textarea,
              content_en: this.en_textarea,
            };
            if (this.zh_link != "") {
              params.link_zh = this.zh_link;
            }
            if (this.en_link != "") {
              params.link_en = this.en_link;
            } 
            if (this.status == 4 && this.send_person != "") {
              params.send_object = this.status;
              params.phone = this.send_person.split(",");
            }else {
              params.send_object = this.status;
            }
            push_add(params).then((res) => {
              if (res.code == 20000) {
                this.$message.success("提交成功");
                this.zh_textarea = "";
                this.en_textarea = "";
                this.zh_link = "";
                this.en_link = "";
                this.zh_name = "";
                this.en_name = "";
                this.send_person = "";
                this.page = 1;
                // this.getData();
              } else {
                this.$message.error(res.msg);
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$message.error("请确认您的输入内容！");
      }
    },
    hidePanel(event) {
      var sp = document.getElementById("emjioBox");
      var sp2 = document.getElementById("emjioBox2");
      if (sp) {
        if (!sp.contains(event.target)) {
          //这句是说如果我们点击到了id为myPanel以外的区域
          this.viewEmjio = false;
        }
      }
      if (sp2) {
        if (!sp2.contains(event.target)) {
          //这句是说如果我们点击到了id为myPanel以外的区域
          this.viewEmjio2 = false;
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
section {
  .checked {
    border: 1px solid #00dc41;
  }
  height: calc(100% - 60px);
  .title {
    font-size: 18px;
    color: #141414;
    line-height: 60px;
    letter-spacing: 0.4px;
    text-align: left;
  }
  .mbTip {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px;
    background-color: #ffebdb;
    border: 2px solid #ffbe89;
    font-size: 14px;
    line-height: 23px;
    margin: 14px 0 15px 0;
    color: #666;
  }
  .showTextarea {
    width: 100% !important;
    .msgEdit {
      width: 48%;
    }
  }
  .textarea {
    width: 85%;
    display: flex;
    min-height: 280px;
    justify-content: space-between;
    .msgEdit {
      // width: 100%;
      height: 200px;
      position: relative;
      .emjioBox {
        position: absolute;
        top: -90px;
        width: 688px;
        height: 180px;
        border: 1px solid #e1e1e1;
        background-color: #fff;
        z-index: 999;
        .emjioMain {
          width: calc(100% - 160px);
          height: 140px;
          padding: 20px;
          box-sizing: border-box;
          overflow-y: auto;
          position: relative;
          span {
            width: 35px;
            height: 35px;
            display: inline-block;
            font-size: 23px;
            cursor: pointer;
            border: 1px solid transparent;
            line-height: 35px;
            text-align: center;
            margin: 0 2px 2px 0;
            transition: all 0.5s;
            &:hover {
              border-color: darkcyan;
            }
          }
        }
        .viewEmjio {
          position: absolute;
          right: 0;
          top: 0px;
          width: 160px;
          height: 140px;
          border-left: 1px solid #e1e1e1;
          line-height: 140px;
          text-align: center;
          font-size: 80px;
        }
        .emjioList {
          width: 100%;
          height: 40px;
          background-color: #f1f1f1;
          span {
            display: inline-block;
            width: 43px;
            height: 100%;
            text-align: center;
            line-height: 40px;
            font-size: 12px;
            color: #555;
            transition: all 0.5s;
            &:hover {
              background-color: #e1e1e1;
              cursor: pointer;
            }
          }
        }
      }
      .msgTools {
        width: 100%;
        height: 35px;
        span {
          display: inline-block;
          margin-top: 8px;
          margin-right: 5px;
          font-size: 20px;
          width: 25px;
          height: 25px;
          transition: all 0.5s;
          text-align: center;
          img {
            width: 90%;
            height: 90%;
          }
        }
      }
      #msgContent,
      #msgContent2 {
        width: calc(100% - 20px);
        height: 100px;
        border: 1px solid #f1f1f1;
        padding: 10px;
        font-size: 14px;
        color: #666;
        resize: none;
      }
    }
    div {
      width: 45%;
      p {
        line-height: 42px;
        letter-spacing: 0.3px;
        font-size: 16px;
        color: #141414;
        margin-right: 20px;
      }
      /deep/ .el-textarea {
        width: 100%;
        /deep/ .el-textarea__inner {
          // 然后找到对应的类名，在这里将拉伸去掉即可
          resize: none;
        }
      }
    }
  }
  .send_person {
   /deep/ .el-radio-group {
     display: flex;
     width: 100%;
    /deep/ .el-radio {
      margin-right: 10px;
    }
    /deep/ .el-input {
        display: inline-block;
        margin-left: 10px;
        width: 260px !important;
      }
  } 
  }
  

  .submit {
    width: 85%;
    margin: 10px 0 20px;
    text-align: right;
    /deep/ .el-button {
      width: 100px;
    }
  }
  .sendContent {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .row-height {
    height: 40px;
    line-height: 40px;
    .row-span + .row-span {
      margin-left: 15px;
    }
    .row-total {
      margin-left: 30px;
      font-size: 16px;
      font-weight: bold;
      padding: 0 30px 10px 0;
    }
  }
}
</style>